import Hero from '../components/home/Hero';
import Stats from '../components/home/Stats';
import Integration from '../components/home/Integration';
import Brands from '../components/home/Brands';
import Features from '../components/home/Features';
import Process from '../components/home/Process';
import How from '../components/home/How';
import Contact from '../components/home/Contact';
function Home() {
  return (
    <div>
      <Hero />
      <Brands />
      <Process/>
      <Stats />
      <Integration />
      <How/>
      <Features /> 
      <Contact />
    </div>
  );
}

export default Home;